
/**
 * 뉴스 기본 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroBasicInfoAllOfTwo = {
  publishedAt: string;
  title: string;
};
